import { providerKey } from './ProviderMap.jsx';
import skinclusiveBadge from '../assets/skinclusive-badge.png';

/**
 * Left-column list of up to 5 provider results.
 * Clicking an item highlights the corresponding map marker (and vice versa).
 */
export default function ProviderList({ providers, highlightedKey, onHighlight }) {
  return (
    <ul className="pf-providerlist" role="list">
      {providers.map(p => {
        const key = providerKey(p);
        const active = key === highlightedKey;
        return (
          <li
            key={key}
            className={`pf-provideritem ${active ? 'is-active' : ''}`}
            onClick={() => onHighlight(active ? null : key)}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onHighlight(active ? null : key);
              }
            }}
            role="button"
            tabIndex={0}
          >
            <div className="pf-provideritem__name">{p.store_name}</div>
            <div className="pf-provideritem__address">{p.address}</div>
            {p.is_skinclusive && (
              <img
                className="pf-provideritem__skinclusive"
                src={skinclusiveBadge}
                alt="Skinclusive Provider"
              />
            )}
            {p.web && (
              <a
                className="pf-provideritem__website"
                href={p.web}
                target="_blank"
                rel="noopener noreferrer"
                onClick={e => e.stopPropagation()}
              >
                Visit Website
              </a>
            )}
            <div className="pf-provideritem__distance">
              {p.distance != null && `${p.distance.toFixed(1)} miles`}
            </div>
          </li>
        );
      })}
    </ul>
  );
}
